export const LastUpdated = '15 janvier 2025';
